import { Dialog } from '@/components/Dialog';
import { Kbd } from '@/components/Misc';
import { useUiStore } from '@/stores/ui';
import { isMac } from '@/lib/format';

const groups: Array<{ title: string; rows: Array<[string, string]> }> = [
  { title: 'Global', rows: [['/', 'Focus search'], ['⌘/Ctrl K', 'Command palette'], ['?', 'This dialog'], ['Esc', 'Clear selection / close']] },
  { title: 'Grid', rows: [['← → ↑ ↓', 'Move focus'], ['Shift + click', 'Select range'], ['⌘/Ctrl + click', 'Toggle'], ['⌘/Ctrl A', 'Select all loaded'], ['Enter', 'Open asset'], ['Space', 'Quick look'], ['Drag', 'Move to board (Alt = copy)']] },
  { title: 'Asset viewer', rows: [['Space / K', 'Play / pause'], ['J / L', 'Rewind / fast-forward'], [', / .', 'Previous / next frame'], ['← / →', '±5 s (Shift: ±1 s)'], ['Home / End', 'Start / end'], ['M', 'Mute'], ['F', 'Fullscreen'], ['C', 'Comment at current frame'], ['I / O', 'Loop in / out'], ['[ / ]', 'Previous / next asset']] },
];

export function ShortcutsDialog() {
  const open = useUiStore((s) => s.shortcutsOpen);
  const setOpen = useUiStore((s) => s.setShortcutsOpen);
  if (!open) return null;
  const mod = isMac() ? '⌘' : 'Ctrl';
  return (
    <Dialog open onClose={() => setOpen(false)} title="Keyboard shortcuts" width="max-w-2xl">
      <div className="grid gap-6 sm:grid-cols-3">
        {groups.map((g) => (
          <section key={g.title}>
            <h3 className="mb-2 text-xs font-semibold tracking-wide text-fg-subtle uppercase">{g.title}</h3>
            <dl className="space-y-1.5 text-sm">
              {g.rows.map(([k, v]) => (
                <div key={k} className="flex items-center justify-between gap-3">
                  <dt className="text-fg-muted">{v}</dt>
                  <dd>
                    <Kbd>{k.replace('⌘/Ctrl', mod)}</Kbd>
                  </dd>
                </div>
              ))}
            </dl>
          </section>
        ))}
      </div>
    </Dialog>
  );
}
